import React from "react";
import PropTypes from "prop-types";
import ReportsTable from "./components/ReportsTable";
import { fairnessColumns } from "./utils/columnsDefinition";

const FairnessReport = ({ data }) => {
	let reportData = [];
	if (data && data.OfficerList) {
		reportData = [...data.OfficerList];

		reportData.push({
			Name: "Total",
			JobsScheduled: data.TotalJobsScheduled || 0,
			JobsApplied: data.TotalJobsApplied || 0,
			JobsScheduled30Day: data.TotalJobsScheduled30Day || 0,
			HoursScheduled30Day: data.TotalHoursScheduled30Day || 0,
			JobsScheduledPercentage: data.TotalJobsScheduledPercentage || 0,
			Id: -1,
		});
	}

	return (
		<div className="panel reports-panel">
			<div className="panel-content">
				<ReportsTable
					hideTitle
					data={reportData}
					tableColumn={fairnessColumns()}
				/>
			</div>
		</div>
	);
};

FairnessReport.propTypes = {
	data: PropTypes.array,
};

FairnessReport.defaultProps = {
	data: [],
};
export default FairnessReport;
